import {
  type EncounterRefusal,
  type EncounterRejected,
  type EncounterRescued,
  getItem,
} from '@shefira/shared';

import { uiFormat, uiNumber, uiText } from './text.js';

/** One line per refusal of the peddler or a lost chest (ADR 0093). */
export const ENCOUNTER_REFUSAL_LINES: Readonly<Record<EncounterRefusal, string>> = {
  invalid: 'Demande invalide.',
  unknown: 'Trop tard : la rencontre a repris la route.',
  'too-far': 'Approche-toi encore un peu.',
  dead: 'Relève-toi d’abord.',
  'sold-out': 'Tu lui as déjà acheté son lot.',
  opened: 'Tu as déjà vidé ce coffre.',
  'missing-gold': 'Ta bourse n’y suffit pas.',
  'bag-full': 'Ton sac est plein.',
  failed: 'Un souci est survenu, rien n’a été dépensé : réessaie.',
};

export function encounterRefusalText(rejected: EncounterRejected): string {
  return uiText(ENCOUNTER_REFUSAL_LINES[rejected.reason]);
}

/** « Croc de loup ×2, Potion » : what fell, in the reader's language. */
export function lotsText(items: readonly { templateId: string; quantity: number }[]): string {
  return items
    .map((item) => {
      const name = uiText(getItem(item.templateId)?.name ?? item.templateId);
      return item.quantity > 1 ? `${name} ×${String(item.quantity)}` : name;
    })
    .join(', ');
}

/** The rescuer's line in the chat, after the thanks the server announces. */
export function rescuedText(rescued: EncounterRescued): string {
  if (rescued.items.length === 0)
    return uiFormat('Voyageuse sauvée : +{xp} XP.', { xp: uiNumber(rescued.xp) });
  return uiFormat('Voyageuse sauvée : +{xp} XP, et à tes pieds : {items}.', {
    xp: uiNumber(rescued.xp),
    items: lotsText(rescued.items),
  });
}
